import { toast, ToastOptions } from "react-toastify";
import { useThemeProvider } from "../utils/ThemeContext";

export const useToaster = () => {
  const { currentTheme } = useThemeProvider();

  const toastSettings: ToastOptions = {
    pauseOnHover: false,
    draggable: false,
    theme: currentTheme === "dark" ? "dark" : "light",
  };
  const showInfo = (message: string) => {
    toast.info(message, toastSettings);
  };

  const showSuccess = (message: string) => {
    toast.success(message, toastSettings);
  };

  const showError = (message: string) => {
    toast.error(message, toastSettings);
  };

  const showWarning = (message: string) => {
    toast.warn(message, toastSettings);
  };

  return { showInfo, showSuccess, showError, showWarning };
};
